var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.decideComponent,{tag:"component",staticClass:"uyasd3ap",class:[
    { loading: _vm.isLoading },
    { disabled: _vm.disabled },
    { rounded: _vm.rounded },
    _vm.type,
    _vm.size
  ],attrs:{"href":_vm.href,"to":_vm.to,"target":_vm.target,"disabled":_vm.disabled,"tabindex":"0"},on:{"click":function($event){return _vm.$emit('click')},"focus":function($event){return _vm.$emit('focus')},"blur":function($event){return _vm.$emit('blur')}}},[_vm._t("default"),_c('div',{staticClass:"spinner"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }